import React, { useEffect, useState } from 'react';
import CustomTable from '../../components/Tables/CustomTable';
import TableActionButtons from '../../components/Buttons/TableActionButtons';
import CustomModal from '../../components/Modals/CustomModal';
import ConfirmModal from '../../components/Modals/ConfirmModal';
import ToastManager from '../../components/Toast/ToastManager';
import SaveButton from '../../components/Buttons/SaveButton';
import VincularGravidezForm from '../../components/Forms/VincularGravidezForm';
import VincularConsultaForm from '../../components/Forms/VincularConsultaForm';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { getUserProfile } from '../../utils/auth';
import { useToast } from '../../hooks/useToast';
import SearchBar from '../../components/SearchBar/SearchBar';

const DEFAULT_PAGE = 1;
const DEFAULT_SIZE = 10;
const DEFAULT_SEARCH_TERM = '';

const GestanteIndexPage = () => {
  const [data, setData] = useState([]);
  const [isGravidezModalOpen, setGravidezModalOpen] = useState(false);
  const [selectedGestante, setSelectedGestante] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [historicoGestante, setHistoricoGestante] = useState([]);
  const [isConsultaModalOpen, setConsultaModalOpen] = useState(false);
  const [gestanteSelecionada, setGestanteSelecionada] = useState(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [searchTerm, setSearchTerm] = useState(DEFAULT_SEARCH_TERM);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [openExcluirGestanteModal, setOpenExcluirGestanteModal] = useState(false);
  const [gestanteToDelete, setGestanteToDelete] = useState(null);
  const [gestanteParaToggle, setGestanteParaToggle] = useState(null);
  const userProfile = getUserProfile();
  const { toasts, removeToast, showSuccess, showError } = useToast();

  // Função para buscar as gestantes
  const fetchData = async (page = DEFAULT_PAGE, size = DEFAULT_SIZE, searchTerm = DEFAULT_SEARCH_TERM) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get('/gestante/list', {
        params: { page, size, search: searchTerm.trim() }
      });

      const { data: pregnancyData, pagination } = response.data;

      setData(pregnancyData);
      setCurrentPage(pagination.current_page);
      setHasNextPage(pagination.has_next);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setError('Usuário não autorizado. Por favor, faça login.');
        setTimeout(() => {
          navigate('/');
        }, 3000);
      }
      else {
        console.error('Erro ao carregar os dados:', error);
        setError('Erro ao carregar os dados');
      }
    } finally {
      setLoading(false);
    }
  };

  // Função para habilitar/desabilitar uma gestante
  const handleToggleStatus = async (item) => {
    const isActive = item.habilitado;
    const action = isActive ? 'desabilitar' : 'habilitar';
    const endpoint = isActive ? '/disable' : '/enable';

    try {
      await api.put(`/gestante/${item.cpf}${endpoint}`);

      // Atualiza o status local da gestante
      setData((prevData) =>
        prevData.map((row) =>
          row.cpf === item.cpf
            ? { ...row, habilitado: !isActive }
            : row
        )
      );

      showSuccess(`Gestante ${action === 'habilitar' ? 'habilitada' : 'desabilitada'} com sucesso!`);
    } catch (error) {
      console.error(`Erro ao ${action} o registro:`, error);
      showError(`Erro ao ${action} o registro`);
    }
  };

  // Função para abrir a modal de confirmação
  const handleOpenConfirmModal = (item) => {
    setGestanteParaToggle(item);
    setConfirmModalOpen(true);
  };

  const handleOpenConfirmExcluirGestante = (item) => {
    setGestanteToDelete(item);
    setOpenExcluirGestanteModal(true);

  };

  const handleConfirmExcluirGestante = async () => {
    if (gestanteToDelete) {
      setOpenExcluirGestanteModal(false);
      setGestanteToDelete(null);

      try {
        await api.delete(`/gestante/${gestanteToDelete.cpf}/delete`);
        await fetchData(currentPage, DEFAULT_SIZE, searchTerm);
        showSuccess('Gestante deletada com sucesso!');
      } catch (error) {
        console.error('Erro ao deletar a gestante:', error);
        showError('Erro ao deletar a gestante');
      }
    }
  };
  // Função para confirmar a ação
  const handleConfirmToggle = () => {
    if (gestanteParaToggle) {
      handleToggleStatus(gestanteParaToggle);
      setGestanteParaToggle(null);
    }
  };

  const handleVincularConsulta = (gestante) => {
    setGestanteSelecionada(gestante);
    setConsultaModalOpen(true);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleView = (item) => {
    navigate(`/gestante/view/${item.cpf}`);
  };

  const handleVincularGravidez = async (gestante) => {
    try {
      const response = await api.get(`/gestante/${gestante.cpf}/consultas`);
      setHistoricoGestante(response.data);
      setSelectedGestante(gestante);
      setGravidezModalOpen(true);
    } catch (error) {
      console.error('Erro ao buscar histórico da gestante:', error);
      setHistoricoGestante([]);
    }
  };



  return (
    <div>

      {["Administrador", "Gestor Municipal", "Regional"].includes(userProfile) && (
        <div style={{ display: 'flex', gap: '10px' }}>
          <SaveButton
            label={'Adicionar Gestante'}
            onClick={() => navigate('/gestante/create')}
          />
          <SaveButton
            label={'Entrega de Kits em lote'}
            onClick={() => navigate('/gestante/registrar-entrega-kits-lote')}
          />
        </div>
      )}

      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p style={{ color: '#1a1a1a' }}>{error}</p>
      ) : (
        <>
          <SearchBar
            placeholder={'Buscar por CPF, ou nome, ou Município...'}
            value={searchTerm}
            onChange={setSearchTerm}
            onSearch={(term) => {
              setSearchTerm(term);
              fetchData(DEFAULT_PAGE, DEFAULT_SIZE, term);
            }}
          />
          <CustomTable
            columns={[
              { field: 'cpf_formatado', headerName: 'CPF' },
              { field: 'nome', headerName: 'Nome da Gestante' },
              { field: 'cns', headerName: 'CNS da Gestante' },
              { field: 'municipio_cod_ibge', headerName: 'Cod. Município' },
              { field: 'nome_municipio', headerName: 'Nome Município' },
              { field: 'status_display', headerName: 'Status da Gestante' }
            ]}
            data={data.map(gestante => ({
              ...gestante,
              nome_municipio: gestante.municipio.nome,
              cpf_formatado: gestante.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
              status_display: gestante.habilitado ? 'Ativa' : 'Inativa',
            }))}


            renderActions={(row) => (
              <>
                <TableActionButtons
                  onView={() => handleView(row)}
                  onEdit={() => navigate(`/gestante/edit/${row.cpf}`)}
                  onDelete={() => handleOpenConfirmModal(row)}
                  onUndelete={() => handleOpenConfirmModal(row)}
                  showDelete={row.habilitado}
                  showUndelete={!row.habilitado}
                  showExcluirGestante={["Administrador", "Regional"].includes(userProfile)}
                  excluirGestanteDisabled={!row.habilitado}
                  onExcluirGestante={() => handleOpenConfirmExcluirGestante(row)}
                />
              </>
            )}
            currentPage={currentPage}
            hasNextPage={hasNextPage}
            onPageChange={(page) => fetchData(page, DEFAULT_SIZE, searchTerm)}
          />
        </>
      )}

      {/* Modal para Vincular Gravidez */}
      <CustomModal isOpen={isGravidezModalOpen} onClose={() => setGravidezModalOpen(false)} title="Vincular Gestação">
        {selectedGestante &&
          <div>
            <VincularGravidezForm gestacao={historicoGestante} gestante={selectedGestante} onClose={() => setGravidezModalOpen(false)} />
          </div>
        }
      </CustomModal>


      {/* Modal para Vincular Consulta */}
      <CustomModal isOpen={isConsultaModalOpen} onClose={() => setConsultaModalOpen(false)} title="Vincular Consulta">
        {gestanteSelecionada && (
          <VincularConsultaForm
            gestanteCpf={gestanteSelecionada.cpf}
            onClose={() => setConsultaModalOpen(false)}
            onConsultaVinculada={() => fetchData(currentPage, DEFAULT_SIZE, searchTerm)}
          />
        )}
      </CustomModal>

      {/* Modal de confirmação para habilitar/desabilitar gestante */}
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
          setGestanteParaToggle(null);
        }}
        onConfirm={handleConfirmToggle}
        title="Confirmação"
        message={
          gestanteParaToggle
            ? `Deseja ${gestanteParaToggle.habilitado ? 'desabilitar' : 'habilitar'} a gestante ${gestanteParaToggle.nome}?`
            : ''
        }
        confirmText={gestanteParaToggle?.habilitado ? 'Desabilitar' : 'Habilitar'}
        confirmButtonColor={gestanteParaToggle?.habilitado ? '#1a1a1a' : '#595959'}
      />

      {/* Modal de confirmação para excluir gestante */}
      <ConfirmModal
        isOpen={openExcluirGestanteModal}
        onClose={() => {
          setOpenExcluirGestanteModal(false);
          setGestanteToDelete(null);
        }}
        onConfirm={handleConfirmExcluirGestante}
        title="Confirmação"
        message="Você tem certeza que deseja excluir esta gestante? Essa ação é irreversível."
        confirmText="Excluir"
        confirmButtonColor="#1a1a1a"
      />

      {/* Toast Manager para notificações */}
      <ToastManager toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default GestanteIndexPage;
